import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class MensajeDmService {
  private mostrarSubject = new BehaviorSubject<boolean>(false);
  mostrarMensaje$ = this.mostrarSubject.asObservable();

  private titulo: string = '';
  private texto: string = '';

  setMensaje(titulo: string, mensaje: string) {
    this.titulo = titulo;
    this.texto = mensaje;
    this.mostrarSubject.next(true);
  }

  ocultarMensaje() {
    this.mostrarSubject.next(false);
  }

  getTitulo() {
    return this.titulo;
  }

  getMensaje() {
    return this.texto;
  }
}


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/services/mensaje-dm.service.ts